import React, { SVGProps } from "react";

export default function SupTalk(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M16 8.5L16.6 9.3C17.1842 10.0789 17.5 11.0263 17.5 12C17.5 12.9737 17.1842 13.9211 16.6 14.7L16 15.5L17.5 17H11.6056C9.353 17 7.24949 15.8742 6 14M5 7H12M5 9H10M7.16464 3H9.5C12.2614 3 14.5 5.23858 14.5 8C14.5 10.7614 12.2614 13 9.5 13H3V13C3.76737 12.2326 3.58241 10.9276 3.04916 9.98246C2.69471 9.35421 2.5 8.63619 2.5 7.8915L2.5 7.66464C2.5 5.08843 4.58843 3 7.16464 3Z"
        stroke="currentColor"
      />
    </svg>
  );
}
